import { Col, Row } from "antd";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getHealthStates,
  getSponsoredOrphansWithPagination,
  getSponsorshipAmounts,
} from "../../../../../apis/actions/sponsor.actions";
import { AppDispatch, RootState } from "../../../../../apis/store";
import PrimaryButton from "../../../../../biblio/Buttons/PrimaryButton";
import DotsLoader from "../../../../../biblio/Loader/DotsLoader";
import ModalComponent from "../../../../../biblio/Modal/ModalComponent";
import PaginationComponent from "../../../../../biblio/Pagination/PaginationComponent";
import Selects from "../../../../../biblio/Selects/Selects";
import {
  scroll,
  showNotitfication,
} from "../../../../../components/utils/utils";
import SponsorResult from "../SponsorResult";
import { sponsorshipType, switchOptions } from "../utils";
import AllUnsponsoredOrphansWidows from "./AllUnsponsoredOrphansWidows";
import UnsponsoredOrphansCollapse from "./UnsponsoredOrphansCollapse";
import RenewSponsorShip from "../renewSponsorship/RenewSponsorShip";
import { setRenewAll } from "../../../../../apis/slices/moyasarSlice";
import { SwitchAccountSelect } from "../../profile/SwitchAccountSelect";

interface Props {
  orphans: any[];
  type: "sponsored" | "unsponsored";
}
const OrphansSponsorshipOverview = ({ orphans, type }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const currentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    dispatch(getHealthStates());
    dispatch(getSponsorshipAmounts());
  }, [dispatch]);
  const [selectedType, setSelectedType] = useState<string | null>(null);
  const [selectedCategory] = useState<string | null>(null);
  const [selectedItems, setSelctedItems] = useState<any[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const { loading } = useSelector(
    (state: RootState) => state?.sponsor
  );
  const {
    sponsorDetails,
    sponsoredWithPagination,
    TotalSponsoredWithPagination,
  } = useSelector((state: RootState) => state?.sponsor);
  const OtpId = useSelector((state: RootState) => state?.recipient?.OtpId);
  const hasRelatedAccounts = sponsorDetails?.related_accounts?.length > 0;

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };

  const itemPerPage = 8;
  useEffect(() => {
    setSelctedItems([]);
    setSelectedType(null);
  }, [type]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        await dispatch(
          getSponsoredOrphansWithPagination({
            sponsor_id: OtpId,
            limit: itemPerPage,
            page: currentPage,
            sponsorship_type: selectedType,
          })
        );
      } catch (error) {
        console.error("Failed to fetch sponsoredOrphans:", error);
      }
    };
    fetchData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, currentPage, selectedType, itemPerPage]);
  const handleSelectTypeChange = (value: any) => {
    if (value) {
      setSelectedType(value?.value);
    } else {
      setSelectedType(null);
    }
    setCurrentPage(1);
  };

  const toAddOrRemoveItem = (item: any) => {
    const index = selectedItems.findIndex((i: any) => i.id === item.id);
    const list = [...selectedItems];
    if (index === -1 && type === "unsponsored") {
      if (sponsorDetails?.overdue_amount > 0) {
        return showNotitfication(
          "لا يمكن إضافة كفالة جديدة إلا بعد تسوية جميع المتأخرات",
          "error"
        );
      }

      if (sponsorDetails?.cancelled_booking === true) {
        return showNotitfication(
          "لقد تجاوزت عدد الإلغاءات المسموح بها. يرجى إضافة مبلغ إلى المحفظة للسماح لك بطلب كفالة",
          "error"
        );
      }
      if (sponsorDetails?.unpaid_booking_number > 0) {
        return showNotitfication(
          "لا يمكنك تقديم طلب كفالة جديدة نظرًا لوجود طلب سابق غير مدفوع",
          "error"
        );
      }
      /*
      if (
        sponsorDetails?.surplus_amount < totalAmount &&
        selectedItems?.length >= sponsorshipAmount?.number_orphans_reserved
      ) {
        return showNotitfication(
          `لا يمكنك حجز أكثر من ${sponsorshipAmount?.number_orphans_reserved} في المرة الواحدة`,
          "error"
        );
      }
      if (
        sponsorDetails?.surplus_amount < totalAmount &&
        sponsorDetails?.surplus_amount > 200
      ) {
        return showNotitfication("لا يمكن إضافة كفالة جديدة", "error");
      }
      */
    }
    if (index !== -1) {
      list.splice(index, 1);
      setSelctedItems([...list]);
    } else {
      item.month = 1;
      item.amount = item.sponnsorShipAmount;
      setSelctedItems([...list, item]);
    }
  };

  const handleChange = (items: any[]) => {
    const list: any[] = [];
    selectedItems.forEach((el) => {
      const index = sponsoredWithPagination.findIndex(
        (i: any) => i.id === el.id
      );
      // eslint-disable-next-line eqeqeq
      if (index == -1) list.push(el);
    });
    selectedItems.forEach((el) => {
      const index = items.findIndex((i: any) => i.id === el.id);
      if (index !== -1) list.push(items[index]);
    });
    setSelctedItems(list);
  };
  const typeSelect = (
    <Selects
      options={
        type === "unsponsored" && selectedCategory
          ? switchOptions(selectedCategory)
          : sponsorshipType
      }
      value={
        type === "unsponsored" && selectedCategory === "أرملة"
          ? "أرملة"
          : selectedType
      }
      selectPlaceholder="نوع الكفالة"
      onChange={handleSelectTypeChange}
      allowClear={true}
      className="takaful--service-select takaful--request-select"
      popupClassName="takaful--service-select-dropdown"
    />
  );
  return (
    <>
      {type === "unsponsored" ? (
        <Row gutter={8} dir="rtl" style={{ marginBottom: "1.5rem" }}>
          <Col xxl={12} xl={11} lg={12} md={12} sm={24} xs={24}>
            <span className="takaful--service-section-title">الكفالات</span>
          </Col>
          <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12}>
            {typeSelect}
          </Col>
        </Row>
      ) : (
        <Row
          gutter={[8, 8]}
          dir="rtl"
          justify="space-between"
          align="middle"
          style={{ marginBottom: "1.5rem" }}
        >
          <Col>
            <span className="takaful--service-section-title">
              تجديد كفالاتي
            </span>
          </Col>
          {hasRelatedAccounts && (
            <Col>
              <SwitchAccountSelect
                relatedAccounts={sponsorDetails?.related_accounts}
                accountsNumber={sponsorDetails?.accounts_number}
              />
            </Col>
          )}
        </Row>
      )}
      {type === "sponsored" && (
        <div className="takaful--renew-sponsorship-container-btn">
          <PrimaryButton
            onClick={() => {
              setModalVisible(true);
              setSelctedItems([]);
              dispatch(setRenewAll(true));
            }}
            title="تجديد كفالة كل أيتامي و أراملي"
            className="takaful--add-request-btn takaful--renew-sponsorship-btn"
          />
        </div>
      )}
      <SponsorResult
        title=""
        items={selectedItems}
        extra={type === "sponsored" ? typeSelect : undefined}
      />
      {loading ? (
        <div className="takaful--loading-projects-cases">
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : sponsoredWithPagination?.length === 0 && !selectedType ? (
        <p className="takaful--no-services">لا توجد كفالات</p>
      ) : sponsoredWithPagination?.length === 0 && selectedType ? (
        <p className="takaful--no-services">
          لا يوجد كفالات تتوافق مع البحث الذي قمت به
        </p>
      ) : (
        <>
          <Row
            justify={"space-around"}
            ref={currentRef}
            style={{ marginTop: "2rem" }}
          >
            <UnsponsoredOrphansCollapse
              unsponsoredOrphans={sponsoredWithPagination}
              addOrRemoveItem={(e) => toAddOrRemoveItem(e)}
              selectedItems={selectedItems}
              handleChange={(l) => handleChange(l)}
              itemPerPage={itemPerPage}
              currentPage={currentPage}
              type={type}
              surplus_amount={sponsorDetails?.surplus_amount}
            />
          </Row>

          <div className="takaful--pagination-container">
            {sponsoredWithPagination &&
              Math.ceil(TotalSponsoredWithPagination * itemPerPage) >
                itemPerPage && (
                <PaginationComponent
                  active={currentPage}
                  total={Math.ceil(TotalSponsoredWithPagination * itemPerPage)}
                  itemPerPage={itemPerPage}
                  scroll={() => scroll(currentRef)}
                  setActive={(nb) => updateActive(nb)}
                />
              )}
          </div>
          {selectedItems?.length > 0 && (
            <Row
              justify={"end"}
              dir="rtl"
              className="takaful--request-col-space"
            >
              <Col xxl={4} xl={4} lg={6} md={6} sm={8} xs={8}>
                <PrimaryButton
                  onClick={() => setIsModalVisible(true)}
                  title="إعتماد"
                  className="takaful--sponsor-orphan-card-button"
                />
              </Col>
            </Row>
          )}
        </>
      )}
      <ModalComponent
        title=""
        open={isModalVisible}
        onClose={() => {
          setIsModalVisible(false);
        }}
        closeOnOutsideClick={true}
        width={1200}
        modalStyle={{ top: 150 }}
      >
        <AllUnsponsoredOrphansWidows
          selectedItems={selectedItems}
          setSelctedItems={setSelctedItems}
          addOrRemoveItem={(e) => toAddOrRemoveItem(e)}
          openModal={(v) => setIsModalVisible(v)}
          type={type}
          surplus_amount={sponsorDetails?.surplus_amount}
        />
      </ModalComponent>
      <RenewSponsorShip
        visible={modalVisible}
        setVisible={setModalVisible}
        orphans={sponsoredWithPagination}
      />
    </>
  );
};

export default OrphansSponsorshipOverview;
